// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/HeroSlider.tsx
// Version: v1.1.0
// Description: Hero Slider mit AnimatedWindow - Mobile Button Layout Fix

import { useNavigate } from "react-router-dom";
import Container from "../hooks/Container.tsx";
import Button from "./ui/Button.tsx";
import AnimatedCircles from "./animations/AnimatedCircles.tsx";
import AnimatedBlobs from "./animations/AnimatedBlobs.tsx";
import AnimatedWindow from "./animations/AnimatedWindow.tsx"; // NEU!
import { useLanguage } from "../lang/index.lang.tsx";

// ==========================================
// ZENTRALE KONSTANTEN - Exakte Höhen
// ==========================================
const HEADER_HEIGHT = 0; // px - Muss mit HeaderDesktop übereinstimmen!
const SECTION_HEIGHT = "100vh"; // Jede Section ist exakt 1 Viewport hoch
const TOTAL_HEIGHT = "100vh"; // Gesamthöhe für Scroll-Effekt (Hero + Video)
const VERTICAL_OFFSET = 0; // px - Korrektur für Header (50px / 2)

// ==========================================
// PROPS INTERFACE - Alle Texte kommen von außen!
// ==========================================
interface HeroSliderProps {
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
  heroType?: "image" | "circles" | "blobs" | "window"; // NEU: "window" Type hinzugefügt
  heroImage?: string;
  videoSrc?: string;
  videoPoster?: string;
}

const HeroSlider = ({
  title,
  description,
  buttonText,
  buttonLink,
  heroType = "window", // CHANGED: Default auf "window" für neue Animation
  heroImage = "/images/EST-653757072.jpg",
}: HeroSliderProps) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <>
      <style>
        {`
          .hero-bg-responsive {
            background-position: center center;
          }
          @media (min-width: 768px) {
            .hero-bg-responsive {
              background-position: right calc(50% - 25px);
            }
          }
        `}
      </style>

      <div className="relative mb-[50px] md:mb-[50px] lg:mb-[100px]" style={{ height: TOTAL_HEIGHT }}>
        <div
          className="sticky left-0 w-full hero-bg-responsive"
          style={{
            top: `${HEADER_HEIGHT}px`,
            height: SECTION_HEIGHT,
            ...(heroType === "image"
              ? {
                  backgroundImage: `url(${heroImage})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }
              : heroType === "window"
              ? {} // Kein Background nötig - AnimatedWindow handled alles
              : {
                  background: `
                radial-gradient(ellipse at top left, rgba(34, 197, 94, 0.15) 0%, transparent 50%),
                radial-gradient(ellipse at bottom right, rgba(74, 222, 128, 0.12) 0%, transparent 50%),
                linear-gradient(135deg, #0f1419 0%, #1a2332 25%, #0d1117 50%, #1c2834 75%, #0a0e13 100%)
              `,
                }),
          }}
          role="img"
          aria-label={title}
        >
          {/* AnimatedCircles */}
          {heroType === "circles" && (
            <AnimatedCircles
              variant="hero"
              color="green"
              density="high"
              animated
              parallax
              className="z-0"
            />
          )}

          {/* AnimatedBlobs */}
          {heroType === "blobs" && (
            <AnimatedBlobs
              density="high"
              speed="fast"
              parallax
              className="z-0"
            />
          )}

          {/* AnimatedWindow - NEU! */}
          {heroType === "window" && (
            <AnimatedWindow className="z-0 " />
          )}

          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent z-10" />

          <div
            className="absolute inset-0 flex items-center z-20  mb-6"
            style={{ marginTop: `${VERTICAL_OFFSET}px` }}
          >
            <Container>
              <div className="text-white max-w-[1510px] mx-auto px-4 sm:px-6 lg:px-8">
                <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold italic mb-6 md:mb-8 lg:mb-12">
                  {title}
                </h1>

                <p className="text-lg md:text-xl lg:text-3xl leading-relaxed mb-6 md:mb-8 lg:mb-12 max-w-full md:max-w-[50%]">
                  {description}
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <Button to={buttonLink} variant="filled" size="M">
                    Erfahre mehr über uns
                  </Button>
                  <Button to="/services" variant="bordered" size="M">
                    Entdecke unsere Services
                  </Button>
                </div>
              </div>
            </Container>
          </div>
        </div>

        
      </div>
    </>
  );
};

export default HeroSlider;